module.exports = __webpack_public_path__ + "static/media/historyList.14c959da.svg";